import { StorageService } from './services/storage.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipeModule } from './pipes/pips.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImageCropComponent } from './components/image-crop/image-crop.component';
import { ImageUploadComponent } from './components/image-upload/image-upload.component';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ProductImageComponent } from './components/product-image/product-image.component';
import { TimelineComponent } from './components/timeline/timeline.component';
import { ImageCropperComponent } from 'ngx-image-cropper';

@NgModule({
  declarations: [
    ImageCropComponent,
    ImageUploadComponent,
    ProductImageComponent,
    TimelineComponent
  ],
  imports: [
    CommonModule,
    PipeModule,
    FormsModule,
    ReactiveFormsModule,
    NgbTooltipModule,
    ImageCropperComponent
  ],
  exports: [
    CommonModule,
    PipeModule,
    ImageUploadComponent,
    ImageCropComponent,
    ProductImageComponent,
    TimelineComponent
  ],
  providers: [ StorageService ]
})
export class SharedModule { }
